module.exports = __webpack_public_path__ + "static/media/ascending.1829c0f8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/ascending.svg
 ** module id = 607
 ** module chunks = 0
 **/